module.exports = __webpack_public_path__ + "img/kiribati.16650e7.webp";